export const defaultIcons = {
    default: "/assets/defaulticons/logo.png",
    foodrush: "/assets/defaulticons/foodrush.png",
    thabazimbi: "/assets/defaulticons/thabazimbi.png" 
}